import React from "react";
import { useTranslation } from "react-i18next";
import PageShell from "../components/PageShell";
import AboutSection from "../sections/About";

const About = () => {
  const { t } = useTranslation();
  return (
    <PageShell title={t("about.pageTitle")} mainClass="page">
      <AboutSection />
    </PageShell>
  );
};

export default About;
